export const EXTRA_LARGE_DESKTOP_BREAKPOINT = `@media (min-width: 1200px)`
export const DESKTOP_BREAKPOINT = `@media (min-width: 992px)`
export const LAPTOP_BREAKPOINT = `@media (min-width: 768px)`
export const TABLET_BREAKPOINT = `@media (min-width: 576px)`
// MOBILE_BREAKPOINT is by default
